import { LifecycleStatus } from '@clockwise/shared';

/**
 * Pill badge for the shared LifecycleStatus enum (Active / Inactive / Archived).
 * Active reads emerald; Inactive and Archived both read muted (they're both
 * "not in use", distinguished only by label). Used by the activities catalog
 * and the per-customer activities panel — keep them rendering identically.
 */
export function LifecycleStatusBadge({ status }: { status: LifecycleStatus }) {
  if (status === LifecycleStatus.Active) {
    return (
      <span className="inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200">
        Active
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground">
      {status === LifecycleStatus.Inactive ? 'Inactive' : 'Archived'}
    </span>
  );
}
